module.exports = __webpack_public_path__ + "img/permissions.0705c521.svg";